import axiosConfig from "./axiosConfig";
import Cookies from "js-cookie";

class AuthService {
  // Register a new user
  async register(userData) {
    try {
      const response = await axiosConfig.post("/auth/register", userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Login a user
  async login({ email_user, password }) {
    try {
      const response = await axiosConfig.post("/auth/login", {
        email: email_user,
        password,
      });

      const { access_token } = response.data;

      if (access_token) {
        Cookies.set("access_token", access_token, { expires: 7 });
        Cookies.set("refresh_token", access_token, { expires: 7 });
      } else {
        throw new Error("Token missing in response");
      }

      return response.data;
    } catch (error) {
      console.error("Login request error:", error);
      throw error.response?.data || error.message;
    }
  }

  // Refresh token
  async refreshToken() {
    try {
      const refreshToken = Cookies.get("refresh_token");
      if (!refreshToken) throw new Error("Refresh token is missing");

      const response = await axiosConfig.post("/auth/refresh", {
        refresh_token: refreshToken,
      });
      const { access_token } = response.data;

      if (access_token) {
        Cookies.set("access_token", access_token, { expires: 1 });
      } else {
        this.logout();
        window.location.href = "/auth/sign-in";
        throw new Error("Access token missing in response");
      }

      return response.data;
    } catch (error) {
      console.error("Refresh token request error:", error); // Debugging: Log the error
      this.logout();
      window.location.href = "/auth/sign-in";
      throw error.response?.data || error.message;
    }
  }

  // Get user profile
  async getProfile() {
    try {
      const response = await axiosConfig.get("/auth/profile");
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        this.logout();
        window.location.href = "/auth/sign-in";
      }
      throw error.response?.data || error.message;
    }
  }

  // Logout user
  logout() {
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
  }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;
